import { FileInput } from "./file-input.model";

export const FILE_UPLOAD_IMAGE_INPUTS: Record<string, FileInput> = {
    logoDark: {
        imgType: 'logoDark',
        ref: undefined,
        description: `Puoi allegare il <b>logo dark</b> dell\'azienda in formato JPG o PNG, di 147x90 pixel`,
        defaultDescription: 'Puoi allegare il logo dark dell\'azienda in formato JPG o PNG, di 147x90 pixel',
        width: 147,
        height: 90,
        isUploaded: false,
        accept: '.jpg, .png'
      },
      logoLight: {
        imgType: 'logoLight',
        ref: undefined,
        description: 'Puoi allegare il <b>logo light</b> dell\'azienda in formato JPG o PNG, di 147x90 pixel',
        defaultDescription: 'Puoi allegare il logo light dell\'azienda in formato JPG o PNG, di 147x90 pixel',
        width: 147,
        height: 90,
        isUploaded: false,
        accept: '.jpg, .png'
      },
      favicon: {
        imgType: 'favicon',
        ref: undefined,
        description: 'Puoi allegare il <b>favicon</b> dell\'azienda in formato JPG o PNG, di dimensione 147x90 pixel',
        defaultDescription: 'Puoi allegare il favicon dell\'azienda in formato JPG o PNG, di dimensione 147x90 pixel',
        width: 147,
        height: 90,
        isUploaded: false,
        accept: '.jpg, .png'
      },
      logoAzienda: {
        imgType: 'logoAzienda',
        ref: undefined,
        description: 'Puoi allegare il <b>logo</b> dell\'azienda in formato JPG o PNG, di dimensione 1376x266 pixel',
        defaultDescription: 'Puoi allegare il logo dell\'azienda in formato JPG o PNG, di dimensione 1376x266 pixel',
        width: 1376,
        height: 266,
        isUploaded: false,
        accept: '.jpg, .png'
      },
      firmaAttestato: {
        imgType: 'firmaAttestato',
        ref: undefined,
        description: 'Puoi allegare <b>l\'immagine della firma dell\'attestato</b> in formato JPG o PNG, di dimensione 683x173 pixel',
        defaultDescription: 'Puoi allegare l\'immagine della firma dell\'attestato in formato JPG o PNG, di dimensione 683x173 pixel',
        width: 683,
        height: 173,
        isUploaded: false,
        accept: '.jpg, .png'
      },
      imgFooter:
      {
        imgType: 'imgFooter',
        ref: undefined,
        description: 'Puoi allegare <b>l\'immagine per il footer</b> del rivenditore in formato JPG o PNG, di dimensione 1355x156 pixel',
        defaultDescription: 'Puoi allegare l\'immagine per il footer del rivenditore in formato JPG o PNG, di dimensione 1355x156 pixel',
        width: 1355,
        height: 156,
        isUploaded: false,
        accept: '.jpg, .png'
      }
};
